import { FC, useMemo } from "react";
import moment from "moment/min/moment-with-locales";
import { useDispatch, useSelector } from "react-redux";

import { useBookingEnum } from "@enums/hooks.enum";
import { DateFormats } from "@enums/shared.enum";
import bookingSlice from "@slices/booking.slice";
import { RootState } from "@store/index";
import { toCapitalize } from "@utils/common.utils";

const DateStrip: FC = () => {
  const { calenderStartDate, selectedDate } = useSelector(
    (State: RootState) => State.booking
  );

  const selectedLanguage = useSelector(
    (State: RootState) => State.user.selectedLanguage
  );

  const dispatch = useDispatch();

  const bookingDates = useMemo(() => {
    const totalDays = useBookingEnum.MinDatesOnStrip;

    return Array.from({ length: totalDays }, (_, i) =>
      moment(calenderStartDate)
        .clone()
        .add(i, DateFormats.Days)
        .format(DateFormats.YMD)
    );
  }, [calenderStartDate, selectedDate, selectedLanguage]);

  const changeSelectedDate = (date: string) => {
    dispatch(
      bookingSlice.actions.changeSelectedDate(
        moment(date).format(DateFormats.YMD)
      )
    );
  };

  return (
    <div className="date-picker-wrapper flex">
      {bookingDates.map(date => (
        <button
          key={date}
          onClick={() => {
            changeSelectedDate(date);
          }}
          className={`date-item ${date === selectedDate ? "active" : ""}`}
        >
          {toCapitalize(
            moment(date).locale(selectedLanguage).format(DateFormats.DayMonth)
          )}
        </button>
      ))}
    </div>
  );
};

export default DateStrip;
